import { Component, Input, OnInit, ChangeDetectionStrategy } from '@angular/core'
import { SaveForm, untilDestroy, ConfirmDialogService } from '@tokeet-frontend/tv3-platform'
import { AutopilotAutomationBaseComponent } from '@tv3/containers/automations/automations-wizard/short-automations/autopilot-automation.component'
import { AmplitudeService } from '@tv3/services/amplitude.service'
import { Store } from '@ngrx/store'
import { Actions, ofType } from '@ngrx/effects'
import {
  AutomationWizardCloseAction,
  AutomationWizardSaveAction,
} from '@tv3/containers/automations/automations-wizard/automations-wizard.actions'
import { FormBuilder, UntypedFormControl, UntypedFormGroup } from '@angular/forms'
import { AutomationHandler, AutomationTypes } from '@tokeet-frontend/automations'
import { filter } from 'rxjs/operators'

@Component({
  selector: 'app-new-expense-automation',
  templateUrl: './new-expense-automation.component.html',
  styleUrls: ['./new-expense-automation.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class NewExpenseAutomationComponent extends AutopilotAutomationBaseComponent implements OnInit {
  @Input() type = AutomationTypes.Expense
  @Input() handler = AutomationHandler.ExpenseCreateHandler

  // predefined expense data
  _expenseData: any
  @Input() set expense(data: any) {
    this.form.patchValue({ data }, { emitEvent: false })
    this._expenseData = data
  }
  get expense() {
    return this._expenseData
  }

  constructor(
    private actions: Actions,
    protected store: Store<any>,
    protected amplitudeService: AmplitudeService,
    protected confirm: ConfirmDialogService
  ) {
    super(store, amplitudeService, confirm)
    this.form.addControl('data', new UntypedFormControl())
  }

  ngOnInit(): void {
    super.ngOnInit()

    this.automation$.pipe(untilDestroy(this)).subscribe((item) => {
      this.form.patchValue(
        {
          data: item?.settings?.expense || this.expense,
        },
        { emitEvent: false }
      )
    })

    this.actions
      .pipe(
        ofType(AutomationWizardSaveAction),
        filter(() => this.viewType !== 'table'),
        untilDestroy(this)
      )
      .subscribe((action) => {
        if (this.automationGroup) {
          this.doSave(this.form, action.closeAfterSave)
        } else if (action.closeAfterSave) {
          this.store.dispatch(AutomationWizardCloseAction())
        }
      })
  }

  tryToCreateOrUpdateAutomation(status: boolean) {
    if (this.automationGroup) {
      this.toggleAutomation(status)
    } else {
      this.doSave(this.form)
    }
  }

  @SaveForm()
  doSave(form: UntypedFormGroup, closeAfterSave = false) {
    this.saveAutomation(form.getRawValue())
    if (closeAfterSave) {
      this.store.dispatch(AutomationWizardCloseAction())
    }
  }

  getAutopilotId() {
    return `autopilot-expense|${this.service}|${this.type}|${this.event}|${this.handler}|${this.idSuffix || ''}`
  }

  onSaveData(data: any) {
    this.form.get('data').setValue(data, { emitEvent: false })
    this.doSave(this.form)
  }
}
